import React from 'react';

export default function TabsWrapper({ children, style }) {
	return (
		<div className='tabsWrapper' style={style}>
			{children}
		</div>
	);
}
